module.exports = "/_next/static/images/2-fab387d4cf1492bb69038d1fde8ddc3e.jpg";